// document.addEventListener('DOMContentLoaded', function() {
//   const carousels = document.querySelectorAll('.ps-carousel-slider-navigation');

//   carousels.forEach(carousel => {
//       const buttons = carousel.querySelectorAll('.wp-block-button__link');
//       const allSlides = carousel.querySelectorAll('.glide__slide');

//       buttons.forEach(button => {
//           button.addEventListener('click', function() {
//               const filter = this.getAttribute('data-filter');

//               allSlides.forEach(slide => {
//                   if (filter === 'all') {
//                       slide.style.display = 'block';
//                   } else {
//                       if (slide.classList.contains(filter)) {
//                           slide.style.display = 'block';
//                       } else {
//                           slide.style.display = 'none';
//                       }
//                   }
//               });
//           });
//       });
//   });
// });

// document.addEventListener('DOMContentLoaded', function() {
//   const carousels = document.querySelectorAll('.ps-carousel-slider-navigation-component');
// if(!carousels){
//   return false;
// }
//   carousels.forEach(carousel => {
//       const buttons = carousel.querySelectorAll('.wp-block-button__link');
//       let allSlides = carousel.querySelectorAll('.glide__slide');

//       // Initialize Glide.js with responsive settings
//       const glide = new Glide(carousel.querySelector('.glide'), {
//           type: 'carousel',
//           startAt: 0,
//           perView: 4,
//           breakpoints: {
//               1280: {
//                   perView: 3
//               },
//               960: {
//                   perView: 3
//               },
//               480: {
//                   perView: 2
//               },
//               0: {
//                   perView: 1
//               }
//           },
//           accessibility: true,
//           keyboard: true,
//           gap: 20,
//           autoplay: 3000,
//           hoverpause: true,
//           animationDuration: 800,
//           animationTimingFunc: 'ease-in-out'
//       });

//       glide.mount();

//       // buttons.forEach(button => {
//       //     button.addEventListener('click', function() {
//       //         const filter = this.getAttribute('data-filter');

//       //         allSlides.forEach(slide => {
//       //             if (filter === 'all') {
//       //                 slide.style.display = 'block';
//       //             } else {
//       //                 if (slide.classList.contains(filter)) {
//       //                     slide.style.display = 'block';
//       //                 } else {
//       //                     slide.style.display = 'none';
//       //                 }
//       //             }
//       //         });

//       //         // Reinitialize Glide slider after filtering
//       //         glide.destroy();
//       //         glide.mount();
//       //     });
//       // });

//       // Function to remove a slide and reinitialize Glide
//       function removeSlide(slideIndex) {
//           const slide = allSlides[slideIndex];
//           if (slide) {
//               slide.remove();
//               allSlides = carousel.querySelectorAll('.glide__slide'); // Update the slides list
//               glide.destroy();
//               glide.mount();
//           }
//       }

//       // Example usage: Remove the first slide
//       removeSlide(0);
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 960) {
    setupButtonClick();
  }
  enableHorizontalScroll();
  addFilterClassOnClick();
});

document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".ps-carousel-slider-navigation-component");

  function createSlider(glideSlider) {
    // Initialize Glide.js with responsive settings
    const VisibleClass = function (Glide, Components, Events) {
      const Component = {
        mount() {
          this.setVisibleClasses();
        },
        setVisibleClasses() {
          const slides = Components.Html.slides;
          const perView = Glide.settings.perView;
          const index = Glide.index;

          // Remove existing corner classes
          slides.forEach((slide) => {
            slide.classList.remove(
              "glide__slide--left-corner",
              "glide__slide--right-corner"
            );
          });

          // Add class to the first visible slide
          if (slides[index]) {
            slides[index].classList.add("glide__slide--left-corner");
          }

          // Add class to the last visible slide
          if (slides[index + perView - 1]) {
            slides[index + perView - 1].classList.add(
              "glide__slide--right-corner"
            );
          }
        },
      };

      Events.on("run", () => {
        Component.setVisibleClasses();
      });

      return Component;
    };
    // if (items.length > 5) {
    //   glide.mount();
    // }
    // Initialize Glide with the custom component
    const glide = new Glide(glideSlider, {
      type: "slider",
      startAt: 0,
      perView: 4,
      breakpoints: {
        1280: {
          perView: 3.5,
        },
        960: {
          perView: 3,
        },
        768: {
          perView: 2.5,
        },
        480: {
          perView: 1,
          gap: 10,
          peek: {
            before: 0,
            after: 150, // Adjust this value for mobile devices
          },
        },
        0: {
          perView: 1,
        },
      },
      accessibility: true,
      keyboard: true,
      gap: 20,
      autoplay: false,
      hoverpause: true,
      animationDuration: 800,
      animationTimingFunc: "ease-in-out",
      navigation: {
        prev: '.glide__arrow--left', // Previous button
        next: '.glide__arrow--right' // Next button
      }
    });

glide.on(['mount.after', 'run'], () => {
  const slides = glideSlider.querySelectorAll('.glide__slide');

  slides.forEach(slide => {
    const isHidden = slide.getAttribute('aria-hidden') === 'true';

    slide.querySelectorAll('a, button, input, textarea, select').forEach(el => {
      el.tabIndex = isHidden ? -1 : 0;
    });
  });
});

    glide.on("mount.after", () => {
      const totalSlides = glideSlider.querySelectorAll(".glide__slide").length;
      const leftArrow = glideSlider.querySelector(".glide__arrow--left");
      const rightArrow = glideSlider.querySelector(".glide__arrow--right");

      const screenWidth = window.innerWidth;

      let hideArrows = false;

      if (screenWidth > 960 && totalSlides <= 3) {
        hideArrows = true;
      } else if (screenWidth < 960 && screenWidth > 480 && totalSlides < 3) {
        hideArrows = true;
      } else if (screenWidth < 480 && totalSlides < 2) {
        hideArrows = true;
      }

      if (hideArrows) {
        if (leftArrow) leftArrow.style.display = "none";
        if (rightArrow) rightArrow.style.display = "none";
      } else {
        if (leftArrow) leftArrow.style.display = "";
        if (rightArrow) rightArrow.style.display = "";
      }
      
    });
   

    glide.mount({ VisibleClass });
    return glide;


  }
  carousels.forEach((carousel) => {
    const buttons = carousel.querySelectorAll(
      ".netflix-nav-component-buttons .wp-block-button__link"
    );
    let glideSlides = carousel.querySelector(".glide__slides");
    if (!glideSlides) {
      return;
    }
    const allSlides = glideSlides.querySelectorAll(".glide__slide");
    if (!allSlides) {
      return;
    }

    var glideSlider = carousel.querySelector(".glide");
    // var allSlidesArray = Array.prototype.slice.call(allSlides);

    // let bufferSlides = carousel.querySelector(".buffer_slides");
    // let allBufferSlides = bufferSlides.querySelector(".glide__slide");
    let glide = createSlider(glideSlider);

    buttons.forEach((button) => {
      button.addEventListener("click", function () {
        const filter = this.getAttribute("data-filter");
        // empty glideSlides
        while (glideSlides.firstChild) {
          glideSlides.removeChild(glideSlides.firstChild);
        }
        allSlides.forEach((slide) => {
          if (filter === "all") {
            slide.style.display = "block";
            // move all slides to main ul
            glideSlides.appendChild(slide);
          } else {
            if (slide.classList.contains(filter)) {
              glideSlides.appendChild(slide);
            } else {
              //slide.style.display = 'none';
              // slide.remove();
            }
          }
        });
        glide.destroy();
        glide = createSlider(glideSlider);
      });
    });
  });
});

function enableHorizontalScroll() {
  const carouselButtons = document.querySelectorAll(
    ".netflix-nav-component-buttons"
  );

  // Exit early if no buttons are found
  if (carouselButtons.length === 0) {
    return;
  }

  // Add the event listener to each button container
  carouselButtons.forEach((carousel) => {
    carousel.addEventListener("wheel", (event) => {
      event.preventDefault();
      carousel.scrollLeft += event.deltaY;
    });

    // Variables to track touch positions
    let startX;
    let scrollLeft;

    // Touch start event
    carousel.addEventListener("touchstart", (event) => {
      startX = event.touches[0].pageX - carousel.offsetLeft;
      scrollLeft = carousel.scrollLeft;
    });

    // Touch move event
    carousel.addEventListener("touchmove", (event) => {
      event.preventDefault();
      const x = event.touches[0].pageX - carousel.offsetLeft;
      const walk = (x - startX) * 2; // Adjust the multiplier for sensitivity
      carousel.scrollLeft = scrollLeft - walk;
    });
  });
}

function setupButtonClick() {
  const components = document.querySelectorAll('.ps-carousel-slider-navigation-component');

  if (!components) {
    return false;
  }

  components.forEach(component => {
    const slides = component.querySelectorAll('.glide__slide');
    const rightArrow = component.querySelector('.glide__arrow--right');

    if (rightArrow) {
      slides.forEach(slide => {
           slide.addEventListener('click', (e) => {
      const clickedEl = e.target;
      const glideSlide = clickedEl.closest('.glide__slide');

      if (!glideSlide) return;

      // 1. Handle .cross-icon → remove active-slide and exit
      if (clickedEl.closest('.cross-icon')) {
        glideSlide.classList.remove('active-slide');
        return;
      }

      // 2. If clicked on .post-thumbnail or .title
      if (
        clickedEl.closest('.post-thumbnail') ||
        clickedEl.closest('.title')
      ) {
        // Remove active-slide from all others
        document.querySelectorAll('.glide__slide.active-slide').forEach(slideEl => {
          slideEl.classList.remove('active-slide');
        });

        // Add to the clicked one if not already active
        glideSlide.classList.add('active-slide');
      }
    });
        
      });
    }
  });
}

function addFilterClassOnClick() {
  // Select all the filter buttons
  const buttons = document.querySelectorAll('.netflix-nav-component-buttons .wp-block-button__link.wp-element-button');

  // Remove 'active-filter' class from all buttons and add it to the first one by default
  buttons.forEach(button => {
    button.classList.remove('active-filter');
  });
  if (buttons.length > 0) {
    buttons[0].classList.add('active-filter'); // Add 'active-filter' to the first button
  }

  // Add a click event listener for each button
  buttons.forEach(button => {
    button.addEventListener('click', function (event) {
      // Remove 'active-filter' class from all buttons
      buttons.forEach(btn => btn.classList.remove('active-filter'));

      // Add 'active-filter' class to the clicked button
      event.target.classList.add('active-filter');

      // Get the filter value from the button's data-filter attribute
      const filterValue = event.target.getAttribute('data-filter');

      // Log the selected filter (you can use this to filter content or do other actions)
      console.log('Filter selected:', filterValue);

      // Example: Add your filtering logic here based on the filterValue
    });
  });
}

